export { PlaceholderIcon as IngredientsGumbaseIcon } from "./placeholder";
